import * as React from "react";
import {useContext} from "react";
import moment from "moment-timezone";
import {AppStateContext} from "../../App";

/** Laravel / API may return ISO strings or serialized Carbon `{ date: "..." }`. */
export function normalizeApiDateString(input: unknown): string | undefined {
    if (input == null) return undefined;
    if (typeof input === "string" && input.trim()) return input.trim();
    if (typeof input === "object" && input !== null && "date" in input) {
        const d = (input as { date?: unknown }).date;
        if (typeof d === "string" && d.trim()) return d.trim();
    }
    return undefined;
}

export default function FormattedDate({ date_string, format }: { date_string: unknown; format?: string }) {
    const { loggedInUser } = useContext(AppStateContext);
    let timezone = "UTC";
    if (loggedInUser && loggedInUser.customers && loggedInUser.customers.length) {
        timezone = loggedInUser.customers[0].timezone !== "" ? loggedInUser.customers[0].timezone : timezone;
    }
    const normalized = normalizeApiDateString(date_string);
    if (!normalized) {
        return null;
    }
    return (
        <>
            {moment.tz(normalized, "UTC").tz(timezone).format(format ? format : "MMM Do, YYYY H:mm a")}
        </>
    );
}

